module.exports = __webpack_public_path__ + "img/img_2.067e5127.png";